// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchNavbarComponents-cls1_fH1","cls2":"SearchNavbarComponents-cls2_3-J SearchNavbarComponents-cls1_fH1"};